/**
 * cp-live-facade.js
 * 札幌サイクルプラザ独自セクション「LIVE FACADE」モック用スクリプト。
 * Vanilla JS のみ、外部ライブラリ不使用。既存 theme.js には依存しない。
 * 同じSectionが複数配置されても、Theme Editorで再描画されても致命的エラーが出ない設計。
 */
(function () {
  'use strict';

  var ROW_SELECTOR = '[data-cp-row]';
  var LANE_SELECTOR = '[data-cp-pause-lane]';
  var SECTION_SELECTOR = '[data-cp-live-facade]';
  var TRANSITION_MS = { x: 600, y: 150 };
  var LANE_GLIDE_FRACTION = 0.3;

  var reduceMotionMedia = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function prefersReducedMotion() {
    return !!(reduceMotionMedia && reduceMotionMedia.matches);
  }

  function axisTransform(axis, value) {
    return axis === 'y' ? 'translateY(' + value + ')' : 'translateX(' + value + ')';
  }

  function setInstant(el, transform) {
    var previousTransition = el.style.transition;
    el.style.transition = 'none';
    el.style.transform = transform;
    void el.offsetHeight; // reflow を強制して、遷移なしの位置を即時反映させる
    el.style.transition = previousTransition || '';
  }

  function stopRow(row) {
    if (row && row.__cpTimerId) {
      window.clearInterval(row.__cpTimerId);
      row.__cpTimerId = null;
    }
  }

  function stopLane(lane) {
    if (lane && lane.__cpLaneTimerId) {
      window.clearTimeout(lane.__cpLaneTimerId);
      lane.__cpLaneTimerId = null;
    }
  }

  function laneCardCenters(setEl, trackRect) {
    var cards = Array.prototype.slice.call(setEl.querySelectorAll('.cp-card'));
    return cards.map(function (card) {
      var r = card.getBoundingClientRect();
      return (r.left - trackRect.left) + r.width / 2;
    });
  }

  function elementKey(el) {
    if (!el) {
      return '';
    }
    var image = el.querySelector('img');
    var value = image
      ? (image.getAttribute('alt') || image.getAttribute('src') || '')
      : (el.textContent || '');
    return value.replace(/^\s+|\s+$/g, '').toLowerCase();
  }

  function chooseInitialIndex(owner, items, usedKeys) {
    if (!items.length) {
      return 0;
    }

    if (typeof owner.__cpInitialPhase !== 'number') {
      owner.__cpInitialPhase = Math.random();
    }

    var index = Math.min(items.length - 1, Math.floor(owner.__cpInitialPhase * items.length));
    var attempts = 0;
    while (attempts < items.length && usedKeys[elementKey(items[index])]) {
      index = (index + 1) % items.length;
      attempts++;
    }

    // Resize時にも同じ開始位置を再利用し、ページ内ではphaseを一度だけ決める。
    owner.__cpInitialPhase = (index + 0.5) / items.length;
    owner.dataset.cpInitialIndex = String(index);
    owner.dataset.cpInitialKey = elementKey(items[index]);
    return index;
  }

  function rememberInitialKey(usedKeys, owner) {
    var key = owner && owner.dataset ? owner.dataset.cpInitialKey : '';
    if (key) {
      usedKeys[key] = true;
    }
  }

  // 実測したカード中心位置から、各カードをレーン中央へ止めるためのtranslateXを算出し、
  // 「進む(グライド)→カードが中央で止まる(ホールド)」をJSのタイマーで直接制御する。
  // カード枚数はMetaobject側の登録数に応じて可変（1枚以上であれば何枚でも可）。
  // ①(left)は実カード集合(1つ目のset)を先頭→末尾の順で、③(right)は実カード集合(2つ目のset)を末尾→先頭の順で辿り、
  // 最後のホールドの後、複製セット側の隣接カード位置までグライドしてから瞬間的に先頭の位置へ戻す
  // （複製セットは実カードと見た目が完全に同じなので、戻した瞬間はユーザーには分からない）。
  function initLane(lane, usedKeys) {
    if (!lane || lane.dataset.cpLaneReady === 'true') {
      return;
    }

    var track = lane.querySelector('.cp-lane__track');
    var sets = track ? track.querySelectorAll('.cp-lane__set') : [];
    if (!track || sets.length < 2) {
      if (lane) { lane.dataset.cpLaneReady = 'true'; }
      return;
    }

    var direction = lane.getAttribute('data-cp-pause-direction') === 'right' ? 'right' : 'left';
    var durationSec = parseFloat(lane.getAttribute('data-cp-pause-duration'));
    if (!durationSec || isNaN(durationSec) || durationSec <= 0) {
      durationSec = 24;
    }

    track.style.transition = 'none';
    track.style.transform = 'translateX(0px)';
    void track.offsetHeight; // reflowを強制し、未変形状態の実測値を取得する

    var trackRect = track.getBoundingClientRect();
    var laneWidth = lane.clientWidth;
    var cardsFirst = Array.prototype.slice.call(sets[0].querySelectorAll('.cp-card'));
    var cardsSecond = Array.prototype.slice.call(sets[1].querySelectorAll('.cp-card'));
    var centersFirst = laneCardCenters(sets[0], trackRect);
    var centersSecond = laneCardCenters(sets[1], trackRect);

    // カード枚数はMetaobjectの登録件数に応じて可変。両setの実測枚数が一致しない場合は
    // 少ない方に合わせて安全側に倒す（通常は同じ内容を複製しているため一致するはず）。
    var stepCount = Math.min(centersFirst.length, centersSecond.length);

    if (stepCount < 1) {
      lane.dataset.cpLaneReady = 'true';
      return;
    }

    // カードが1枚しかない場合は「進む→止まる」の往復自体が発生しないため、
    // 中央に静止表示するだけにしてタイマーは起動しない。
    if (stepCount === 1) {
      track.style.transform = 'translateX(' + (laneWidth / 2 - centersFirst[0]) + 'px)';
      lane.dataset.cpInitialIndex = '0';
      lane.dataset.cpInitialKey = elementKey(cardsFirst[0]);
      lane.dataset.cpLaneReady = 'true';
      return;
    }

    var seq = [];
    var sequenceCards = [];
    var wrapTarget;
    var i;

    if (direction === 'left') {
      for (i = 0; i < stepCount; i++) {
        seq.push(laneWidth / 2 - centersFirst[i]);
        sequenceCards.push(cardsFirst[i]);
      }
      wrapTarget = laneWidth / 2 - centersSecond[0];
    } else {
      for (i = stepCount - 1; i >= 0; i--) {
        seq.push(laneWidth / 2 - centersSecond[i]);
        sequenceCards.push(cardsSecond[i]);
      }
      wrapTarget = laneWidth / 2 - centersFirst[stepCount - 1];
    }

    var startIndex = chooseInitialIndex(lane, sequenceCards, usedKeys || {});

    if (prefersReducedMotion()) {
      track.style.transform = 'translateX(' + seq[startIndex] + 'px)';
      lane.dataset.cpLaneReady = 'true';
      return;
    }

    var stepMs = (durationSec * 1000) / stepCount;
    var glideMs = Math.max(stepMs * LANE_GLIDE_FRACTION, 400);
    var holdMs = Math.max(stepMs - glideMs, 500);
    var positions = seq.concat([wrapTarget]);
    var idx = startIndex;

    track.style.transform = 'translateX(' + seq[startIndex] + 'px)';
    track.style.transition = 'transform ' + glideMs + 'ms ease-in-out';
    lane.dataset.cpLaneReady = 'true';

    function advance() {
      if (prefersReducedMotion()) {
        stopLane(lane);
        return;
      }

      idx++;
      track.style.transform = 'translateX(' + positions[idx] + 'px)';

      if (idx === positions.length - 1) {
        lane.__cpLaneTimerId = window.setTimeout(function () {
          setInstant(track, 'translateX(' + seq[0] + 'px)');
          idx = 0;
          lane.__cpLaneTimerId = window.setTimeout(advance, holdMs);
        }, glideMs + 30);
      } else {
        lane.__cpLaneTimerId = window.setTimeout(advance, glideMs + holdMs);
      }
    }

    lane.__cpLaneTimerId = window.setTimeout(advance, holdMs);
  }

  function initRow(row, usedKeys) {
    if (!row || row.dataset.cpReady === 'true') {
      return;
    }

    var slides = Array.prototype.slice.call(row.querySelectorAll('.cp-slide'));

    if (slides.length < 2) {
      row.dataset.cpReady = 'true';
      return;
    }

    var axis = row.getAttribute('data-cp-axis') === 'y' ? 'y' : 'x';
    var direction = row.getAttribute('data-cp-direction') || 'left';

    var intervalSec = parseFloat(row.getAttribute('data-cp-interval'));
    if (!intervalSec || isNaN(intervalSec) || intervalSec <= 0) {
      intervalSec = 4;
    }

    var enterValue;
    var exitValue;

    if (axis === 'y') {
      // 上から入って、下へ抜ける「ストン」切替
      enterValue = '-100%';
      exitValue = '100%';
    } else if (direction === 'right') {
      // 左から入って、右へ抜ける
      enterValue = '-100%';
      exitValue = '100%';
    } else {
      // 右から入って、左へ抜ける
      enterValue = '100%';
      exitValue = '-100%';
    }

    var initialIndex = chooseInitialIndex(row, slides, usedKeys || {});

    slides.forEach(function (slide, index) {
      slide.classList.remove('is-active');
      if (index === initialIndex) {
        slide.style.transform = axisTransform(axis, '0%');
        slide.classList.add('is-active');
      } else {
        setInstant(slide, axisTransform(axis, enterValue));
      }
    });

    row.dataset.cpReady = 'true';

    if (prefersReducedMotion()) {
      // 自動アニメーションを開始せず、ランダム化した1枚を静止表示する
      return;
    }

    var current = initialIndex;
    var transitionDuration = axis === 'y' ? TRANSITION_MS.y : TRANSITION_MS.x;
    var tickMs = Math.max(intervalSec * 1000, 1500);

    var timerId = window.setInterval(function () {
      if (prefersReducedMotion()) {
        stopRow(row);
        return;
      }

      var next = (current + 1) % slides.length;
      var leaving = slides[current];
      var entering = slides[next];

      leaving.classList.remove('is-active');
      leaving.style.transform = axisTransform(axis, exitValue);

      entering.style.transform = axisTransform(axis, '0%');
      entering.classList.add('is-active');

      window.setTimeout(function () {
        setInstant(leaving, axisTransform(axis, enterValue));
      }, transitionDuration + 50);

      current = next;
    }, tickMs);

    row.__cpTimerId = timerId;
  }

  function initSection(section) {
    if (!section || !section.querySelectorAll) {
      return;
    }
    var usedKeys = {};
    var rows = Array.prototype.slice.call(section.querySelectorAll(ROW_SELECTOR));
    rows.forEach(function (row) {
      initRow(row, usedKeys);
      rememberInitialKey(usedKeys, row);
    });

    var lanes = Array.prototype.slice.call(section.querySelectorAll(LANE_SELECTOR));
    lanes.forEach(function (lane) {
      initLane(lane, usedKeys);
      rememberInitialKey(usedKeys, lane);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll(SECTION_SELECTOR));
    sections.forEach(initSection);
  }

  function start() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme Editor でSectionが再読み込みされた場合に再初期化する
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) {
      return;
    }
    if (event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      initSection(event.target);
    } else {
      initAll(event.target);
    }
  });

  // Theme EditorでSectionが削除/差し替えされた場合にタイマーを止める
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target || !event.target.querySelectorAll) {
      return;
    }
    var rows = event.target.querySelectorAll(ROW_SELECTOR);
    Array.prototype.forEach.call(rows, stopRow);

    var lanes = event.target.querySelectorAll(LANE_SELECTOR);
    Array.prototype.forEach.call(lanes, stopLane);
  });

  // OS側の「動きを減らす」設定がページ表示中に変更された場合にも追従する
  if (reduceMotionMedia) {
    var handleChange = function () {
      if (!prefersReducedMotion()) {
        return;
      }
      var rows = document.querySelectorAll(ROW_SELECTOR);
      Array.prototype.forEach.call(rows, stopRow);

      var lanes = document.querySelectorAll(LANE_SELECTOR);
      Array.prototype.forEach.call(lanes, stopLane);
    };

    if (typeof reduceMotionMedia.addEventListener === 'function') {
      reduceMotionMedia.addEventListener('change', handleChange);
    } else if (typeof reduceMotionMedia.addListener === 'function') {
      reduceMotionMedia.addListener(handleChange); // Safari旧バージョン向けフォールバック
    }
  }

  // 画面回転・リサイズでカード幅やレーン幅（PCブレークポイント含む）が変わるため、
  // 実測値を使うレーンだけ止めて再計測・再始動する
  var resizeTimerId = null;
  window.addEventListener('resize', function () {
    if (resizeTimerId) {
      window.clearTimeout(resizeTimerId);
    }
    resizeTimerId = window.setTimeout(function () {
      var lanes = document.querySelectorAll(LANE_SELECTOR);
      Array.prototype.forEach.call(lanes, function (lane) {
        stopLane(lane);
        lane.dataset.cpLaneReady = 'false';
        initLane(lane);
      });
    }, 250);
  });
})();
